import * as React from 'react';
import './BorderedWell.scss';

// #region Component Props

interface IProps {
    children: any;
}

// #endregion

export const BorderedWell = (props: IProps) => (
    <div className="bordered-well">
        {props.children}
    </div>
);
